<template>
  <footer id="footer">
    <div class="footer-main-content">
      <div class="footer-links-section">
        <div class="footer-links-container">
          <h3>Snelle links</h3>
          <div class="footer-links">
            <ul class="link-list">
              <li>
                <router-link :to="'/'">Home</router-link>
              </li>
              <li>
                <router-link :to="'/about'">Over ons</router-link>
              </li>
              <li>
                <router-link :to="'/projects'">Projecten</router-link>
              </li>
              <li>
                <router-link :to="'/contact'">Contact</router-link>
              </li>
              <li v-if="!authenticated" class="nav-login">
                <router-link :to="'/login'">Log in</router-link>
              </li>
              <li v-else class="nav-logout">
                <span @click="logout">Log uit</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-sm-section">
        <div class="footer-sm-container">
          <h3>Vind ons op social media</h3>
          <div class="footer-sm">
            <ul>
              <li>
                <a href="https://facebook.com/" target="blanc">
                  <span class="fa-stack fa-lg sm-fb">
                    <font-awesome-layers class="fa-lg">
                      <font-awesome-icon :icon="['far', 'square']" transform="down-2 grow-4" />
                      <font-awesome-icon :icon="['fab', 'facebook-f']" transform="down-2 shrink-4" />
                    </font-awesome-layers>
                  </span>
                </a>
              </li>
              <li>
                <a href="https://twitter.com/" target="blanc">
                  <span class="fa-stack fa-lg sm-tw">
                    <font-awesome-layers class="fa-lg">
                      <font-awesome-icon :icon="['far', 'square']" transform="down-2 grow-4" />
                      <font-awesome-icon :icon="['fab', 'twitter']" transform="down-2 shrink-4" />
                    </font-awesome-layers>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      <small class="copyright">© Bob Vlake Foundation</small>
    </div>
  </footer>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFacebookF, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faSquare } from "@fortawesome/free-regular-svg-icons";

library.add(faFacebookF, faTwitter, faSquare);

export default {
  name: "Footer",
  methods: {
    logout: function() {
      this.$api.post("/user/logout").then(response => {
        if (response.status === 200) {
          sessionStorage.removeItem("authToken");
          this.$updateAxios();
          window.location.reload();
        }
      });
    }
  },
  computed: {
    authenticated: function() {
      return this.$auth;
    }
  }
};
</script>

<style lang="less" scoped>
ul {
  list-style: none;
}

#footer {
  color: #efefef;
  min-height: 250px;
  position: absolute;
  bottom: 0;
  width: 100vw;
  background-color: var(--secondary-color);
  text-align: center;
  display: flex;
  flex-direction: column;

  .footer-main-content {
    flex: 6;
    display: flex;
    flex-direction: row;
    padding: 0 8vw 0 8vw;

    & > * {
      flex: 1;
      margin: auto;
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .footer-sm-container h3 {
      text-align: center;
    }

    .footer-links-container,
    .footer-sm-container {
      margin: auto;
      padding: 50px 0;
      text-align: left;
      width: 50%;
      height: 100%;
      display: flex;
      flex-direction: column;

      h3 {
        flex: 1;
        justify-self: flex-start;
      }

      .footer-links,
      .footer-sm {
        justify-self: flex-end;
        flex-grow: 1;
      }

      .footer-sm {
        display: flex;
        flex-direction: row;
        color: white;
        margin: auto;
        width: 90%;

        ul {
          display: flex;
          justify-content: space-between;
          width: 100%;

          li {
            text-align: center;
          }

          .sm-fb,
          .sm-tw {
            color: #efefef;
            font-size: 2rem;
          }
        }
      }

      .link-list {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;

        & > * {
          flex: 1;
        }

        a,
        span {
          color: #e2e2e2;
          text-decoration: none;
          letter-spacing: 3px;
          font-weight: bold;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
  .footer-copyright {
    flex: 1;
    justify-self: flex-end;
  }
}

@media screen and (max-width: 768px) {
  #footer {
    padding: 0;

    .footer-main-content {
      flex: 1;
    }

    .footer-main-content {
      .footer-links-container,
      .footer-sm-container {
        width: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue